<template>
  <div class="split">
    <div class="header" v-if="list && list.length > 0">
      该订单已被拆成{{packagenum}}个包裹
    </div>
    <ul>
      <li v-if="list && list.length > 0" v-for="(item, index) of list" :key="index" @click="transClick(item)">
        <div class="flex-js-ac logisticsno">
          <p class="f14 over-ell-1">{{'包裹'+parseInt(index+1) + '：' +
            (item.trans_company ? item.trans_company : '')
            + '  '+
            (item.tran_no ? item.tran_no : '')}}</p>
          <p class="f12 color-FC0324" v-if="item.ismergeorder == 1">与其他订单合并发出</p>
        </div>
        <div class="address">
          <ul>
            <li class="trans">
              <p class="flex" v-if="item.trans_desc"><img src="../../assets/images/logistics.png">{{item.trans_desc}}<img src="../../assets/images/jt3.png"></p>
            </li>
          </ul>
        </div>
        <div class="list">
          <ul>
            <li>
              <div class="product">
                <div class="productBox" v-if="item.itemlist && item.itemlist.length <= 1">
                  <div class="img">
                    <img v-lazy="item.itemlist[0].img_path">
                    <goods-tag :goods="item.itemlist[0]"></goods-tag>
                  </div>
                  <div class="proContent">
                    <b>{{item.itemlist[0].name.length > 26 ? item.itemlist[0].name.slice(0, 26) + '...' : item.itemlist[0].name}}</b>
                    <p>
                      <b>{{item.itemlist[0].spec}}</b>
                    </p>
                  </div>
                </div>
                <div v-else-if="item.itemlist && item.itemlist.length  > 1" class="bestSellingSwiper" style="overflow: hidden;position:relative;">
                  <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide v-for="(itemSon, idx) of item.itemlist" :key="idx">
                      <div class="img">
                        <img v-lazy="itemSon.img_path">
                        <goods-tag :goods="itemSon"></goods-tag>
                        <div class="f12 nums">{{itemSon.num}}件</div>
                      </div>
                    </swiper-slide>
                  </swiper>
                </div>
                <span class="totalPrice" :style="item && item.itemlist && item.itemlist.length  > 1 ? {} : {'position': 'static'}" :class="{'totalPriceNoShadow' : item.itemlist && item.itemlist.length  < 4, 'totalPriceShadow' : item.itemlist && item.itemlist.length >= 4}">
                  <b>共{{item.item_nums}}件</b>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import Vue from 'vue'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import { customRequestAjax } from '@/axiosApi'
import goodsTag from '../common/goodsTag'
Vue.use(VueAwesomeSwiper, /* { default global options } */)

export default {
  name: 'splitdetails_order',
  components: {
    goodsTag
  },
  data () {
    return {
      id: this.$route.query.id != '' ? this.$route.query.id : '',
      packagenum: 0,
      list: [],
      swiperOption: {
        autoplay: false,
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        observer: true,
        observeParents: true,
        spaceBetween: 10
      },
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'splitdetails'})
    }
    this.getData()
  },
  methods: {
    getData: function () {
      var url = 'Wxmall/Ordermanage/getOrderPackageInfo?id=' + this.id
      var that = this
      if (this.id != '') {
        customRequestAjax(url).then(res => {
          if (res.data.code === 200) {
            that.list = res.data.list
            that.packagenum = res.data.packagenum ? res.data.packagenum : 0
          }
        })
      }
    },
    transClick: function (items) {
      if (items.tran_no) {
        this.$router.push({path: '/logistics',
          query: {
            id: items.id,
            tranno: items.tran_no
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.list ul li p, .product {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -webkit-justify-content: space-between;
  -o-justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
}
.split {
  >ul {
    >li {
      margin-bottom: 0.11rem;
      >.logisticsno {
        margin: 0.15rem 0.11rem 0.06rem;
        color: #262626;
        p:first-of-type {
          margin-right: 0.1rem;
        }
        p:last-of-type {
          white-space: nowrap;
        }
      }
    }
  }
  .header {
    font-size: 0.12rem;
    color: #FAAF40;
    height: 0.33rem;
    line-height: 0.33rem;
    padding-left: 0.11rem;
    background: #FFF7EF;
    /*position: fixed;*/
    /*left: 0;*/
    /*right: 0;*/
    /*top: 0;*/
    z-index: 10;
  }
  .address {
    background: #fff;
    border-radius: 0.03rem;
    padding: 0.12rem 0.12rem 0.1rem 0.15rem;
    margin:0.06rem 0.11rem 0;
    &.order-top-pad {
      padding-top: 0.35rem;
      position: relative;
    }
    >span {
      position: absolute;
      right: 0;
      top: 0;
      display: block;
      background: #FFECEF;
      padding: 0.04rem 0.11rem;
      border-radius: 0 0.03rem 0 0.03rem;
    }
    ul {
      li{
        p{
          font-size:0.12rem;
          font-weight:600;
          color:rgba(29,30,30,1);
          line-height:0.17rem;
          b {
            display: flex;
            display: -webkit-flex;
            display: -ms-flex;
            display: -o-flex;
            display: -moz-flex;
            align-items: center;
            -webkit-align-items: center;
            -ms-align-items: center;
            -o-align-items: center;
            -moz-align-items: center;
          }
          img{
            margin-top: 0.02rem;
            &:first-of-type {
              width: 0.18rem;
              height: 0.16rem;
              margin-right: 0.05rem;
            }
            &:last-of-type {
              margin-top: 0.035rem;
              width: 0.1rem;
              height: 0.1rem;
              padding: 0 0.015rem;
              margin-left: 0.05rem;
            }
          }
        }
        span {
          color:#6C6C6C;
          line-height:0.16rem;
          margin-top: 0.06rem;
          padding-left: 0.23rem;
          /*overflow: hidden;*/
          font-size:0.11rem;
          /*white-space: nowrap;*/
          display: block;
          &.transTime {
            font-size:0;
            position: relative;
            height: 0.16rem;
          }
          b {
            position: absolute;
            top: 0;
            font-weight:400;
            font-size:0.1rem;
            line-height:0.14rem;
            transform: scale(0.93 );
            -webkit-transform: scale(0.93 );
            -moz-transform: scale(0.93  );
            -ms-transform: scale(0.93 );
            -o-transform: scale(0.93  );
            &:first-of-type {
              left: 0.18rem;
            }
            &:last-of-type {
              right: -0.06rem;
            }
          }
        }
      }
    }
  }
  .list {
    >ul {
      >li {
        background: #fff;
        margin: 0 0.11rem 0;
        padding: 0 0.15rem 0.2rem;
        >p {
          border-bottom: 1px solid #EFEFEF;
          padding-bottom: 0.1rem;
          span {
            display: block;
            b {
              display: block;
              font-weight: 400;
              color: #444444;
              font-size:0.12rem;
              float: left;
              &:last-of-type {
                margin-left: 0.04rem;
                line-height: 0.19rem;
                float: left;
                img {
                  width: 0.19rem;
                  height: 0.19rem;
                  float: right;
                }
              }
            }
          }
          >b {
            display: flex;
            display: -webkit-flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -o-flex;
            align-items: center;
            -webkit-align-items: center;
            -moz-align-items: center;
            -ms-align-items: center;
            -o-align-items: center;
            i {
              display: inline-block;
              font-style: normal;
              color: #292929;
              font-size: 0.12rem;
              line-height: 0.16rem;
              float: left;
              font-weight:400;
            }
            b{
              display: inline-block;
              border-left: 1px solid #D8D8D8;
              margin-left: 0.06rem;
              padding-left: 0.07rem;
              img {
                width:0.12rem;
                height:0.12rem;
              }
            }
          }
        }
        .product {
          /*margin-top: 0.16rem;*/
          position: relative;
          .productBox {
            display: flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -webkit-flex;
            display: -o-flex;
            .img {
              position: relative;
              img {
                &:first-of-type {
                  width: 100%;
                  height: 100%;
                }
              }
              width: 0.8rem;
              height: 0.8rem;
            }
            .proContent {
              margin-left: 0.07rem;
              margin-top: 0.08rem;
              flex: 1;
              -webkit-flex: 1;
              -moz-flex: 1;
              -ms-flex: 1;
              -o-flex: 1;
              >b {
                font-size:0.13rem;
                font-weight:400;
                color:rgba(41,41,41,1);
                line-height:0.18rem;
                display: block;
                margin-bottom: 0.05rem;
              }
              >p{
                align-items: flex-start;
                -moz-align-items: flex-start;
                -ms-align-items: flex-start;
                -webkit-align-items: flex-start;
                -o-align-items: flex-start;
                >b {
                  font-size:0.11rem;
                  font-weight:400;
                  color:rgba(108,108,108,1);
                  line-height:0.16rem;
                  display: block;
                }
              }
            }
          }
          .totalPrice {
            position: absolute;
            right: -0.02rem;
            z-index: 10;
            opacity:0.85;
            height: 0.8rem;
            min-width: 0.55rem;
            display: flex;
            display: -webkit-flex;
            display: -o-flex;
            display: -ms-flex;
            display: -moz-flex;
            flex-direction: column;
            -webkit-flex-direction: column;
            -o-flex-direction: column;
            -ms-flex-direction: column;
            -moz-flex-direction: column;
            justify-content: center;
            -webkit-justify-content: center;
            -o-justify-content: center;
            -ms-justify-content: center;
            -moz-justify-content: center;
            &.totalPriceShadow {
              background:rgba(255,255,255,1);
              box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
              -webkit-box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
              -moz-box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
              -ms-box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
              -o-box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
            }
            &+.totalPriceNoShadow {
              background:rgba(255,255,255,1);
            }
            .price {
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: flex-end;
              -webkit-align-items: flex-end;
              -o-align-items: flex-end;
              -ms-align-items: flex-end;
              -moz-align-items: flex-end;
              font-size: 0.14rem;
              font-weight:600;
              color:#222222;
              line-height:0.14rem;
              &:before {
                content: '￥';
                font-size:0.10rem;
                font-weight:600;
                line-height: 0.14rem;
              }
              i {
                font-size: 0.11rem;
                font-style: normal;
                line-height: 0.14rem;
              }
            }
            >b {
              color: #908D8D;
              font-size: 0.11rem;
              line-height: 0.16rem;
              display: block;
              font-weight:400;
              text-align: center;
              white-space: nowrap;
            }
          }
          .bestSellingSwiper {
            /*padding-right: 0.6rem;*/
            width: 100%;
            .swiper-container {
              padding-right: 0.6rem;
              .swiper-wrapper {
                >.swiper-slide {
                  width: 0.8rem;
                  position: relative;
                  background-color: white;
                  .img {
                    width: 0.8rem;
                    height: 0.8rem;
                    position: relative;
                    .tag{
                      position: absolute;
                      right: 0;
                      top:0;
                      font-size: .12rem;
                      .van-tag{
                        border-radius:0px 0px 0px 2px;
                      }
                    }
                    img {
                      &:first-of-type {
                        width: 100%;
                        height: 100%;
                      }
                    }
                    .nums {
                      color: #ffffff;
                      background: rgba(0, 0, 0, .5);
                      position: absolute;
                      bottom: 0;
                      width: 100%;
                      text-align: center;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .proFooter {
      overflow: hidden;
      padding-top: 0.1rem;
      padding-bottom: 0.2rem;
      padding-right: 0.15rem;
      margin: 0 0.11rem 0;
      background: #fff;
      >.p {
        font-size:0.1rem;
        font-weight:400;
        color:rgba(252,3,36,1);
        line-height:0.26rem;
        float: left;
      }
      .proBtn {
        display: flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -webkit-flex;
        display: -o-flex;
        float: right;
        .grayBtn {
          min-width:0.7rem;
          height: 0.27rem;
          display: block;
          margin-left: 0.1rem;
          border-radius:0.14rem;
          border:1px solid rgba(96,96,96,1);
          font-size:0.12rem;
          font-weight:400;
          color:rgba(38,38,38,1);
          line-height:0.17rem;
          padding: 0.05rem 0.11rem;
          background: none;
          outline: none;
        }
        .redBtn {
          min-width:0.7rem;
          height: 0.27rem;
          display: block;
          margin-left: 0.1rem;
          border-radius:0.14rem;
          border:1px solid #FC0324;
          font-size:0.12rem;
          font-weight:400;
          color:#FC0324;
          line-height:0.17rem;
          padding: 0.05rem 0.11rem;
          background: none;
          outline: none;
        }
      }
    }
  }
  .dialog-close {
    width: 0.2rem;
    height: 0.2rem;
    position: absolute;
    top: 0.06rem;
    right: 0.06rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/splitDetails_order.vue